import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
type Props = {
  children: Record<string, any>;
};

type State = {
  hasError: boolean;
  error: Record<string, any>;
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Record<string, any>) {
    super(props);
    this.state = {
      hasError: false,
      error: {},
    };
  }

  static getDerivedStateFromError(error: Record<string, any>): {
    error: any;
    hasError: boolean;
  } {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      error: error,
    };
  }

  componentDidCatch(
    error: Record<string, any>,
    errorInfo: Record<string, any>
  ) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  getChunkLoadErrorMessage() {
    //  Example of ChunkLoadError
    //   e: ChunkLoadError: Loading chunk 13 failed. (missing: http://192.168.1.4:5000/static/js/13.23ab7b2d.chunk.js) at Function.d.e (http://192.168.1.4:5000/asian/events/:1:5430) at http://192.168.1.4:5000/static/js/main.9779a985.chunk.js:1:465896 at k (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1031110) at Us (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1145959) at Tc (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1132553) at Sc (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1132481) at Ac (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1132344) at gc (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1129310) at http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1078689 at t.unstable_runWithPriority (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1156108)
    // message: "Loading chunk 13 failed.\n(missing: http://192.168.1.4:5000/static/js/13.23ab7b2d.chunk.js)"
    // name: "ChunkLoadError"
    // request: "http://192.168.1.4:5000/static/js/13.23ab7b2d.chunk.js"
    // type: "missing"
    // stack: "ChunkLoadError: Loading chunk 13 failed.\n(missing: http://192.168.1.4:5000/static/js/13.23ab7b2d.chunk.js)\n    at Function.d.e (http://192.168.1.4:5000/asian/events/:1:5430)\n    at http://192.168.1.4:5000/static/js/main.9779a985.chunk.js:1:465896\n    at k (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1031110)\n    at Us (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1145959)\n    at Tc (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1132553)\n    at Sc (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1132481)\n    at Ac (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1132344)\n    at gc (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1129310)\n    at http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1078689\n    at t.unstable_runWithPriority (http://192.168.1.4:5000/static/js/9.efeedf2d.chunk.js:2:1156108)"
    // __proto__: Object
    return <FormattedMessage tagName="span" id="load-error" />;
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      let { message } = this.state.error;

      if (
        this.state.error &&
        this.state.error.name &&
        this.state.error.name === "ChunkLoadError"
      ) {
        message = this.getChunkLoadErrorMessage();
      }

      return (
        <div className="error">
          <p>
            {message} <br></br>
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
